import React, {useEffect, useImperativeHandle, useContext} from 'react';
import {useLocation} from 'react-router-dom';
import {useSnackbar} from 'react-simple-snackbar';
import {isMobile} from 'react-device-detect';

import {config} from '../../../../assets';
import {Context} from '../../../../services';
import Icons from '../../../../assets/svgs/icons';

const CALLER = 'LINKS';

const Link = ({position, current, checkAdvance, onSubmit, prevData, extraData, success, corPrimaria}) => {
  const location = useLocation();
  const corretor = location.search;
  const isCostumer = isMobile ? true : !!corretor;

  const [authState, setAuthState] = useContext(Context);
  const [openSnackSuccess] = useSnackbar(config.snackbar_success);

  useImperativeHandle(ref, () => ({values: () => ({caller: CALLER, data: {}})}));

  const copyLink = async () => {
    await navigator.clipboard.writeText(extraData.link);

    openSnackSuccess('Link copiado.', 3000);
  };

  useEffect(() => {
    if (current === position) checkAdvance({caller: CALLER, status: true});
  });

  return (
    <div className="formStep">
      <div className="controlForms">
        {!isCostumer && (
          <div className="leftSide">
            <h1 style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>Finalizar registro</h1>
            <h3 className="mt-4">
              Prezado corretor, caso tenha alguma informação adicional referente a proposta, favor incluir no campo abaixo.
            </h3>

            <textarea
              rows="5"
              tabIndex={-1}
              placeholder="Observações..."
              name="obs"
              value={authState.obs}
              onChange={(e) => setAuthState({...authState, obs: e.target.value})}
              onBlur={(e) => setAuthState({...authState, obs: e.target.value})}
            />
          </div>
        )}

        <div className="rightSide">
          {isCostumer ? (
            <div>
              <h1 style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>
                {prevData.modal === 0
                  ? 'Agora iremos fazer a vistoria da sua bicicleta.'
                  : 'Agora iremos fazer a vistoria do seu equipamento.'}
              </h1>
              <p style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>
                Para poder seguir, permita a localização do seu dispositivo móvel e clique no botão abaixo para avançar.
              </p>
            </div>
          ) : (
            <div>
              <h1 style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>
                Enviar proposta/ e link de vistoria para o segurado.
              </h1>
            </div>
          )}

          {success ? (
            <div className="successDiv">
              <div className="successText">
                <Icons name="check" size="20px" className="mr-2" color="#34619E" />
                {isCostumer ? (
                  <p>Sucesso! Caso prefira, copie o link abaixo para continuar.</p>
                ) : (
                  <p>Sucesso! Agora falta pouco, envie o link para o segurado.</p>
                )}
              </div>

              <div className="successLink">
                <p>{extraData.link}</p>
                <button type="button" onClick={copyLink}>
                  <Icons name="copy" size="20px" className="mr-2" color="#c3c3c3" />
                </button>
              </div>
              <p>
                Condições gerais e resumo do produto disponíveis em{' '}
                <a target="_blank" href="https://bicisura.com.br/resumo_do_produto.pdf">
                  https://bicisura.com.br/resumo_do_produto.pdf
                </a>
              </p>
            </div>
          ) : (
            ''
          )}

          {isCostumer ? (
            <>
              <div className="successBtns" type="button" onClick={() => onSubmit({tipo: 'link'})}>
                <button tabIndex={-1}>
                  <Icons name="survey" size="20px" className="mr-2" color="#34619E" />
                  <p>Continuar para vistoria</p>
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="successBtns">
                <button tabIndex={-1} type="button" onClick={() => onSubmit({tipo: 'sms'})}>
                  <Icons name="message" size="20px" className="mr-2" color="#34619E" />
                  <p>Enviar o link por SMS</p>
                </button>
                <button
                  tabIndex={-1}
                  type="button"
                  onClick={() => {
                    extraData.link ? copyLink() : onSubmit({tipo: 'link'});
                  }}>
                  <Icons name="copy" size="20px" className="mr-2" color="#34619E" />
                  <p>{extraData.link ? 'Copiar link' : 'Criar link'}</p>
                  <span>(Recomendado)</span>
                </button>
              </div>
              <div className="informationDiv">
                <Icons name="informative" size="15px" className="mr-2" color="#FF0000" />
                <p>O cliente só poderá continuar com o processo através de um dispositivo móvel</p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Link;
export const ref = React.createRef();
